import { render, staticRenderFns } from "./DepartListU.vue?vue&type=template&id=10cbe125&scoped=true"
import script from "./DepartListU.vue?vue&type=script&lang=js"
export * from "./DepartListU.vue?vue&type=script&lang=js"
import style0 from "./DepartListU.vue?vue&type=style&index=0&id=10cbe125&prod&lang=less"
import style1 from "./DepartListU.vue?vue&type=style&index=1&id=10cbe125&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbe125",
  null
  
)

export default component.exports